export const NOTES_ACCESS_ALLOWLIST = [
  'marc@defineholy.com',
  'marc@myfiginsurance.com',
];

export function userHasNotesAccess(account) {
  if (!account || !account.username) return false;
  return NOTES_ACCESS_ALLOWLIST.includes(account.username.toLowerCase());
}
